import { SectionMeta } from "../components/SectionMeta.jsx";

const OLD_MODEL = [
  "Fixed offices",
  "Rigid hierarchies",
  "Endless meetings",
  "Burnout disguised as ambition",
  "Loyalty traded for tenure",
];

const NEW_MODEL = [
  "Fluid collaboration",
  "Distributed talent",
  "AI-powered execution",
  "Purpose-led work",
  "Creative freedom",
];

export function Philosophy() {
  return (
    <section className="section shell" id="philosophy">
      <SectionMeta num="§ 04" label="Philosophy" right="Work is changing. Life should too." />

      <h2 className="h-large reveal section-head-spaced">
        Work is changing.
        <br />
        Life <em>should too.</em>
      </h2>

      <div className="compare reveal">
        <div className="compare-col old">
          <span className="tag">The old model</span>
          <h3>Inheritance.</h3>
          <ul>
            {OLD_MODEL.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="compare-col new">
          <span className="tag tag-lime">The new model</span>
          <h3>Invention.</h3>
          <ul>
            {NEW_MODEL.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      <p className="lead reveal philosophy-lead">
        Alt Tribe exists for people who want to build exceptional things —
        without sacrificing their lives in the process.
      </p>
    </section>
  );
}
